//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import { useUploader } from '@content-drawer/upload/useUploader';

export interface DroppableUploadProps {
  onDragLeave: () => void;
}

export const DroppableOverlay = ({ onDragLeave }: DroppableUploadProps) => {
  const { uploadFile } = useUploader();

  const onUploadFiles = (files: FileList | null) => {
    onDragLeave();
    if (files) {
      const list = Array.from(files);
      list.forEach((file) => uploadFile(file));
    }
  };

  return (
    <Draggable
      onDragLeave={onDragLeave}
      onDragOver={(event) => {
        // Prevent file from being opened
        event.preventDefault();
      }}
      onDrop={(event) => {
        // Prevent file from being opened
        event.preventDefault();
        onUploadFiles(event.dataTransfer.files);
      }}
    />
  );
};

const Draggable = styled.div(
  ({ theme }) => `
    display: flex;
    justify-content: end;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    padding: ${theme.spacings[7]};
  `,
);
